module.exports = __webpack_public_path__ + "static/media/customizable.cc099cea.svg";